import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Query, QueryGetAvailableRegionsArgs } from 'generated/graphql';
import { country, regions } from 'cache';

import * as S from './FiltersSidebar.styles';
import { REGIONS } from 'apollo-client';

export const RegionsFilter = ({ isDisabled }: { isDisabled?: boolean }): JSX.Element => {
  const { formatMessage } = useIntl();
  const regionsFilters = useReactiveVar(regions);
  const countryFilter = useReactiveVar(country);

  const [onGetAvailableRegions, { loading, data }] = useLazyQuery<Query, QueryGetAvailableRegionsArgs>(REGIONS, {
    fetchPolicy: 'network-only',
  });

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.regions.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isDisabled={isDisabled}
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.regions.placeholder' })}
        options={data?.getAvailableRegions?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={regionsFilters?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailableRegions({ variables: { inputRegion: e, inputCountry: countryFilter } });
        }}
        onClick={(): void => {
          onGetAvailableRegions({ variables: { inputRegion: '', inputCountry: countryFilter } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          regions(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
